module.exports = __webpack_public_path__ + "static/img/last-page-disabled.4da85339.svg";